import React from "react";
import { Box } from "@mui/material";

import "./index.sass";

export const InternalContent = ({ children }) => {
  return (
    <Box className="internal-content">
      {children}
    </Box>
  );
};
export default InternalContent;
